export default __webpack_public_path__ + "static/media/instagram.592f460b.svg";